import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { Callout, Checkbox, OtpInput, StepActions, PageHeader } from "@components/ui_v2";
import { PATHS_TOFU_V2 } from "@helpers/constantes";

export const NipBuro = () => {
  const navigate = useNavigate();
  const [nipOtp, setNipOtp] = useState("");
  const [nipVerified, setNipVerified] = useState(false);

  const onBack = () => navigate(PATHS_TOFU_V2.cargaDocumentos.path);
  const onNext = () => navigate(PATHS_TOFU_V2.usoDeCredito.path);

  const otpListo = nipOtp.length === 4;

  return (
    <Box>
      <PageHeader
        eyebrow="Autorización · Buró de Crédito"
        title="Autoriza la consulta a Buró de Crédito"
        subtitle="Enviamos un código de 4 dígitos por SMS y WhatsApp para autorizar la consulta."
      />

      <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "background.paper", borderRadius: 2, p: 3, mb: 2 }}>
        <OtpInput length={4} value={nipOtp} onChange={setNipOtp} />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          El código expira en 5 minutos.
        </Typography>
      </Box>

      <Box sx={{ bgcolor: "background.paper", border: "1px solid", borderColor: "background.paper", borderRadius: 2, p: 3 }}>
        <Checkbox
          checked={nipVerified}
          onChange={setNipVerified}
          disabled={!otpListo}
          label="Autorizo a Lendit Group SAPI de CV a consultar mi información ante Buró de Crédito Empresas."
        />
        <Box sx={{ mt: 2 }}>
          <Callout tone="neutral">
            Realizaremos una evaluación que nos determinará la factibilidad de poder acceder a financiamiento.
          </Callout>
        </Box>
      </Box>

      <StepActions onBack={onBack} onNext={onNext} nextDisabled={!otpListo || !nipVerified} />
    </Box>
  );
};
